export const REQUEST_TIMEOUT = 20000;
export const ZIPCODE_LENGTH = 5;
export const ADDRESSES_PAGE_SIZE = 21;
export const ADDRESSES_LIMIT_B2C = 50;
export const ADDRESSES_LIMIT_B2B = 500;
export const PAYMENTS_PAGE_SIZE = 21;
export const RECAPTCHA_TEST_SITE_KEY =
  '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';
export const PAGINATION_THRESHOLD = 20;
export const PAGINATION_JUMP_CONTROLS_THRESHOLD = 11;

export enum Environment {
  DEV = 'DEV',
  STAGE = 'STAGE',
  PROD = 'PROD',
}
